import React, { useEffect } from "react";
import GoogleMapEmbed from "../../components/UserSideComponents/Contact/GoogleMapEmbed";
import ContactForm from "../../components/UserSideComponents/Contact/ContactForm";
import img from "../../Assets/banner.png";
import Banner from "../../components/UserSideComponents/common/Banner";

const Contact = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);
  return (
    <>
      <Banner image={img} heading={"Contact Us"} />
      <ContactForm />
      <GoogleMapEmbed />
    </>
  );
};

export default Contact;
